import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import AliceCarousel from 'react-alice-carousel';
import { TranslateContext } from 'core/translate';
import { SvgIcon } from 'core/icons';
import 'react-alice-carousel/lib/alice-carousel.css';
import { connect } from 'react-redux';
import PriceWithDisclaimer from '../../steps/config/priceWithDisclaimer/PriceWithDisclaimer';
import { combineClassNames } from '../../../core/css';

const handleDragStart = (e) => e.preventDefault();

const Slide = ({ content, val, displayPrice, modifier }) => {
  const msrp = content?.message
    ? content?.msrp
    : get(content, 'msrp.amount.value');
  const message = content?.message || get(content, 'msrp.unknown');

  return (
    <div
      data-value={val + 1}
      className="nav-slide"
      onDragStart={handleDragStart}>
      <div
        className={combineClassNames(
          'nav-slide__name',
          modifier ? `nav-slide__name--${modifier}` : ''
        )}>
        {content.primaryText}
      </div>
      {displayPrice && (msrp || message) && (
        <div className="nav-slide__msrp">
          <TranslateContext.Consumer>
            {(translate) => (
              <PriceWithDisclaimer
                classIdentifier="carousel"
                value={msrp}
                message={message}
                disclaimer={translate(
                  'byo.page.general.disclaimer.msrp.simple'
                )}
                useModal
              />
            )}
          </TranslateContext.Consumer>
        </div>
      )}
    </div>
  );
};

const CarouselNavigation = ({
  slideData,
  navIndex,
  onSlideChange,
  breakpoint,
  displayPrice = false,
  smallLabelNext,
  labelNext,
  smallLabelPrev,
  labelPrev,
  analyticsKey,
  modifier,
}) => {
  const [activeIndex, setActiveIndex] = useState(navIndex);
  const [content, setContent] = useState(null);

  useEffect(() => {
    const carouselSlides = slideData.map((carouselContent, index) => (
      <Slide
        key={carouselContent.slideKey}
        displayPrice={displayPrice}
        val={index}
        content={carouselContent}
        modifier={modifier}
      />
    ));

    setContent(carouselSlides);
  }, []);

  const slidePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const slideNext = () => {
    if (activeIndex < slideData.length - 1) setActiveIndex(activeIndex + 1);
  };

  const onSlideChanged = ({ item }) => {
    onSlideChange(slideData[item]);
    setActiveIndex(item);
  };

  const previousTrimName =
    activeIndex > 0 ? slideData[activeIndex - 1].primaryText : '';

  const nextTrimName =
    activeIndex < slideData.length - 1
      ? slideData[activeIndex + 1].primaryText
      : '';

  const isExtraSmallBreakpoint =
    breakpoint === 'xsmall' && breakpoint !== 'small';
  const isMediumBreakpoint =
    breakpoint === 'medium' ||
    breakpoint === 'small' ||
    breakpoint === 'xsmall';

  return (
    <div
      className={`carousel-nav ${modifier ? 'carousel-nav--' + modifier : ''}`}>
      {content ? (
        <>
          <AliceCarousel
            mouseTracking
            disableDotsControls
            disableButtonsControls
            items={content}
            activeIndex={activeIndex}
            onSlideChanged={onSlideChanged}
          />
          {previousTrimName ? (
            <div
              className="carousel-nav__button-container carousel-nav__button-container--left stat-arrow-prev"
              data-dtm={analyticsKey}>
              <button onClick={slidePrev} className="carousel-nav__button">
                <SvgIcon
                  name="chevron-left"
                  className="carousel-nav__chevron"
                />
                <div className="carousel-nav__button-label carousel-nav__button-label--previous">
                  {isExtraSmallBreakpoint ? null : (
                    <div className="carousel-nav__button-label-direction">
                      {isMediumBreakpoint ? smallLabelPrev : labelPrev}
                    </div>
                  )}
                  {isMediumBreakpoint ? null : (
                    <div className="carousel-nav__button-label-trim">
                      {previousTrimName}
                    </div>
                  )}
                </div>
              </button>
            </div>
          ) : null}
          {nextTrimName ? (
            <div
              className="carousel-nav__button-container carousel-nav__button-container--right stat-arrow-next"
              data-dtm={analyticsKey}>
              <button
                onClick={slideNext}
                className={`carousel-nav__button ${
                  !nextTrimName ? 'carousel-nav__button--disabled' : ''
                }`}>
                <div className="carousel-nav__button-label carousel-nav__button-label--next">
                  {isExtraSmallBreakpoint ? null : (
                    <div className="carousel-nav__button-label-direction">
                      {isMediumBreakpoint ? smallLabelNext : labelNext}
                    </div>
                  )}
                  {isMediumBreakpoint ? null : (
                    <div className="carousel-nav__button-label-trim">
                      {nextTrimName}
                    </div>
                  )}
                </div>
                <SvgIcon
                  name="chevron-right"
                  className="carousel-nav__chevron"
                />
              </button>
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
};
const mapStateToProps = (state) => {
  const { breakpoint } = state;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(CarouselNavigation);
